import {
  createSpecializedRouting,
  getSpecializedRoutings,
  getSpecializedRoutingById,
  updateSpecializedRouting,
  deleteSpecializedRouting,
  updateSpecializedStop,
  updateSpecializedRoutingState,
} from '@/services/api/specialized-routing/specialized-routing'
import { notifyApiFailure } from '@/utils/apiError'

export default {
  namespaced: true,
  state: {
    loading: false,
    allSpecializedRoutingsLoading: false,
    specializedRoutings: [],
    currentSpecializedRouting: {},
    specializedStartTime: null, // this is used to record when user starts the routing
  },
  mutations: {
    SET_SPECIALIZED_ROUTINGS(state, specializedRoutings) {
      state.specializedRoutings = specializedRoutings
    },
    SET_CURRENT_SPECIALIZED_ROUTING(state, currentSpecializedRouting) {
      if (
        currentSpecializedRouting != undefined &&
        currentSpecializedRouting != null
      ) {
        state.currentSpecializedRouting = currentSpecializedRouting
      }
    },
    SET_SPECIALIZED_START_TIME(state, specializedStartTime) {
      state.specializedStartTime = specializedStartTime
    },
    SET_ALL_SPECIALIZED_ROUTINGS_LOADING(state, allSpecializedRoutingsLoading) {
      state.allSpecializedRoutingsLoading = allSpecializedRoutingsLoading
    },
  },
  actions: {
    async getSpecializedRoutings({ commit }, payload) {
      commit('SET_ALL_SPECIALIZED_ROUTINGS_LOADING', true)
      return getSpecializedRoutings(payload)
        .then((response) => {
          const sortedRoutings = response.data.data.map((routing) => {
            return {
              ...routing,
              stops: [...routing.stops].sort((a, b) => a.index - b.index), // Sort stops by index
            }
          })

          commit('SET_SPECIALIZED_ROUTINGS', sortedRoutings)
          commit('SET_ALL_SPECIALIZED_ROUTINGS_LOADING', false)
          return response.data
        })
        .catch((error) => {
          console.error(error)
          commit('SET_ALL_SPECIALIZED_ROUTINGS_LOADING', false)
        })
    },
    async getSpecializedRoutingById({ commit }, payload) {
      return getSpecializedRoutingById(payload)
        .then((response) => {
          const specializedRouting = response.data

          // Sort stops by index
          specializedRouting.stops.sort((a, b) => a.index - b.index)

          commit('SET_CURRENT_SPECIALIZED_ROUTING', specializedRouting)
          return specializedRouting
        })
        .catch((error) => {
          console.error(error)
        })
    },
    async createSpecializedRouting({ commit }, payload) {
      return createSpecializedRouting(payload)
        .then((response) => {
          commit(
            'notification/NEW',
            {
              type: 'success',
              message: 'Success',
              description: 'Specialized Routing Created Successfully',
            },
            { root: true },
          )
          return response.data
        })
        .catch((error) => {
          // Resolve undefined on failure: callers test the result instead of
          // catching, so throwing here would break every `!!result` check.
          notifyApiFailure(commit, 'Route not created', error)
        })
    },
    async updateSpecializedRouting({ commit }, payload) {
      return updateSpecializedRouting(payload)
        .then((response) => {
          return response.data
        })
        .catch((error) => {
          notifyApiFailure(commit, 'Route not updated', error)
        })
    },
    async updateSpecializedStop({ commit }, payload) {
      return updateSpecializedStop(payload)
        .then((response) => {
          return response.data
        })
        .catch((error) => {
          notifyApiFailure(commit, 'Stop not updated', error)
        })
    },
    async updateSpecializedRoutingState({ commit }, payload) {
      return updateSpecializedRoutingState(payload)
        .then((response) => response.data)
        .catch((error) => {
          notifyApiFailure(commit, 'Route not updated', error)
        })
    },
    async deleteSpecializedRouting({ commit }, payload) {
      return deleteSpecializedRouting(payload)
        .then(() => {})
        .catch((error) => {
          console.error(error)
          throw error
        })
    },
    setSpecializedStartTime({ commit }, payload) {
      commit('SET_SPECIALIZED_START_TIME', payload)
    },
  },
  getters: {},
}
